export enum WindowSizeEnum{
    Desktop = 1281,
	Tablet = 1024,
    Mobile = 768
}

export enum WindowSizePXEnum{
    md = '1200px',
    xs = '767px',
    xxs = '440px'
}

export interface IFilter{
    id : number,
    name : string
    value?: string
}

export interface IOptionWithOwnInput{
    id : number | null,
    name : string
}